/* Preguntas frecuentes: una sola respuesta abierta a la vez (respaldo para navegadores que no entienden <details name="...">). */
(function () {
  'use strict';
  if (window.__mgFaq) return;
  window.__mgFaq = true;
  var items = document.querySelectorAll('.mg-faq__item');
  Array.prototype.forEach.call(items, function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      Array.prototype.forEach.call(items, function (o) { if (o !== d) o.open = false; });
    });
  });
})();
